import React, { useState, useEffect } from 'react'
import Select from 'react-select'

import gql from 'graphql-tag'

import { find as _find } from 'lodash'
import { useQuery } from "@apollo/react-hooks";
import { FormGroup, Label} from 'reactstrap'

const query = gql`
  query Sectors($where: SectorWhereInput!) {
    sectors(where: $where) {
      id
      name
    }
  }
`

export const SectorSelect = ({
  item,
  municipalityId,
  onSelect,
  selectProps = {},
}) => {
  const [values, setValues] = useState([])
  const [selected, setSelected] = useState({})

  const skip = !municipalityId
  const { data, loading } = useQuery(query, {
    skip,
    variables: {
      where: {
        municipalityId
      }
    }
  });

  useEffect(() => {
    if (!loading && data) {
      setValues((data.sectors || []).map(value => ({
        label: value.name,
        value
      })));
    }
  }, [loading, data]);

  useEffect(() => {
    setSelected(_find(values, ({ value })=> (parseInt(value.id, 10) === parseInt((item || {}).id) )))
  }, [item, values])

  const onChange = (vItem) => {
    setSelected(vItem)
    onSelect(vItem.value)
  }

  return (
    <>
      <FormGroup>
        <Label>Sector</Label>

        <Select
          classNamePrefix="dhn-select"
          value={selected || null}
          options={values}
          isLoading={loading}
          placeholder='Selecciona un sector'
          onChange={onChange}
          {...selectProps}
        />
      </FormGroup>
    </>
  )
}
